/**
 * Representa os possíveis índices do menu da barra lateral (toolbar) da tela da análise instantânea
 */
export enum ToolbarMenuIndices {
  TIME = 0,
  LAYERS = 1,
  ROUTES = 2
}